<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-form :model="serchParams" class="demo-form-inline" :inline="true">
        <el-row :gutter="24">
          <el-form-item label="类别名称">
            <el-input
                v-model="serchParams.name"
                class="mb10"
                style="width: 240px"
                placeholder="请输入类别名称"
                clearable
            />
          </el-form-item>
          <el-button class="ml10 mb10" type="primary" @click="getList">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-row>
      </el-form>

      <!--        <el-button class="ma" type="primary" @click="handleAddCustomer('add')">+添加客户</el-button>-->
    </div>
    <div class="d-flex" style="margin-bottom: 20px">
      <el-button class=" mb10" type="primary" @click="handleAddPageClass('add')">+添加类别</el-button>
    </div>
    <el-table
        ref="table"
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        lazy
        :load="load"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @expand-change="handleExpandChange"
        class="custom-tree-table"
    >
      <el-table-column
          prop="name"
          label="类别名称"
          align="left"
      />
      <el-table-column
          prop="fullName"
          label="层级全称"
          align="center"
      />
      <el-table-column
          prop="sort"
          label="排序"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
      >
      </el-table-column>
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editCustomer(scope.row)">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消"
                         @confirm="delPageClass(scope.row)" icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          class=""
          :total="total"
          :pager-count="5"
      />
    </div>
    <AddDialog ref="addPageClassDialog" @saveRefresh="saveRefresh"></AddDialog>
  </div>
</template>

<script>
import AddDialog from './components/AddDialog.vue'
import {selectcategoryList, addOrUpdateCategory, delCategory} from '@/api/productCategory.js'

export default {
  components: {
    AddDialog,
  },
  props: {},
  data() {
    return {
      name: null,
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      serchParams: {
        name: ''
      },
      mapstableTree: new Map(),
      tableTreeRefreshTool: {},
    };
  },
  created() {
    this.getList()
  },
  methods: {
    resetSearch() {
      this.serchParams.name = ''
      this.pageNum = 1
      this.getList()
    },
    load(tree, treeNode, resolve) {
      //增删改的时候存储数据
      this.mapstableTree.set(tree.id, {tree, treeNode, resolve})
      // 在之前声明的全局变量中，增加一个key为 本条数据的id，id可替换为你数据中的任意唯一值
      this.tableTreeRefreshTool[tree.id] = {}
      //  重要！保存resolve方法，以便后续使用
      this.tableTreeRefreshTool[tree.id].resolve = resolve
      //  记录展开次数，具体作用后续介绍
      this.tableTreeRefreshTool[tree.id].expandCount = 0
      let params = {
        noPage: true,
        name: this.name,
        parentId: tree.id
      }
      selectcategoryList(params).then(res => {
        resolve(res.data.list)
      })
    },
    //封装一个增删改刷新table数据的方法,组件懒加载数据的节点，data return的maps，及被操作节点的父节点
    refreshLoadTree (lazyTreeNodeMap, maps, parentId) {
      console.log(maps.get(parentId))
      console.log(parentId)
      if (maps.get(parentId)) {
        const { tree, treeNode, resolve } = maps.get(parentId)
        this.$set(lazyTreeNodeMap, parentId, [])
        if (tree) { // 重新执行父节点加载子级操作
          this.load(tree, treeNode, resolve)
          if (tree.parentId) { // 若存在爷爷结点，则执行爷爷节点加载子级操作，防止最后一个子节点被删除后父节点不显示删除按钮
            const a = maps.get(tree.parentId)
            this.load(a.tree, a.treeNode, a.resolve)
          }
        }
      }else {
        this.getList()
      }
    },
    saveRefresh(id){
      console.log('id',id)
      this.refreshLoadTree(this.$refs.table.store.states.lazyTreeNodeMap, this.mapstableTree, id)
    },
    handleExpandChange (row, expanded) {
      const curr = this.tableTreeRefreshTool[row.id]
      curr.expandCount++
      // 如果是展开状态，且展开次数大于1，且上一次的状态为折叠，则请求api数据，更新子菜单
      if (expanded && curr.expandCount > 1 && !curr.prevStatus) {
        let params = {
          noPage: true,
          name: this.name,
          parentId: row.id
        }
        selectcategoryList(params).then(res => {
          resolve(res.data.list)
        })
      }
      // 保存本次的展开或折叠状态，用于下次判断
      curr.prevStatus = expanded
    },
    getCustomer() {
      this.getList()
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAddPageClass(type) {
      this.$refs.addPageClassDialog.openDialog(type)
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      Object.assign(params, this.serchParams)
      selectcategoryList(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    editCustomer(data) {
      this.$refs.addPageClassDialog.openDialog('edit', data)
    },
    delPageClass(data) {
      delCategory({id: data.id}).then(res => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.saveRefresh(data.parentId)
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}

.pageBox {
  display: flex;
  justify-content: flex-end;
}
.custom-tree-table .el-table__expand-icon {
  vertical-align: middle; /* 垂直居中 */
  margin-left: -8px; /* 根据需要调整边距 */
}
                     // 对齐根节点 无论有无子节点
///deep/.el-table [class*=el-table__row--level] .el-table__expand-icon{
//  float: left;
//
//}
</style>

